import * as React from "react";
const IconSession = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.9863 18.9924V21.9924M12.9863 21.9924H9.98633M12.9863 21.9924H15.9863M14.9863 7.99243C14.9863 6.88786 14.0909 5.99243 12.9863 5.99243C11.8818 5.99243 10.9863 6.88786 10.9863 7.99243C10.9863 9.097 11.8818 9.99243 12.9863 9.99243C14.0909 9.99243 14.9863 9.097 14.9863 7.99243ZM6.98633 18.9924H18.9863C21.1955 18.9924 22.9863 17.2016 22.9863 14.9924V5.99243C22.9863 3.78329 21.1955 1.99243 18.9863 1.99243H6.98633C4.77719 1.99243 2.98633 3.78329 2.98633 5.99243V14.9924C2.98633 17.2016 4.77719 18.9924 6.98633 18.9924ZM10.4863 14.9924H15.4863C16.3148 14.9924 16.9863 14.3209 16.9863 13.4924C16.9863 12.664 16.3148 11.9924 15.4863 11.9924H10.4863C9.6579 11.9924 8.98633 12.664 8.98633 13.4924C8.98633 14.3209 9.6579 14.9924 10.4863 14.9924Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconSession;
